module.exports = __webpack_public_path__ + "198f6ae39de020914836c8be0b772f91.png";